// src/config/emailSignIn.js
//
// Email sign-in (mission 007, Fable decision 02) is behind REACT_APP_EMAIL_SIGNIN=on.
// Off: today's wallet-only sign-in, unchanged. Read at call time so tests can
// toggle it; CRA inlines the value at build time.

/** an email session cannot sign: the copy shown wherever an ETH payment would be (007 02c) */
export const EMAIL_PAYMENT_COPY = 'Card payments are coming; until then paid actions need ETH on Base from a connected wallet.';
export const EMAIL_SESSION_COPY = `You're signed in with email. ${EMAIL_PAYMENT_COPY}`;

export const emailSignInEnabled = () => process.env.REACT_APP_EMAIL_SIGNIN === 'on';

/** the label of a control that opens the sign-in modal: "Sign in" when email sign-in is on */
export const signInLabel = (legacy) => (emailSignInEnabled() ? 'Sign in' : legacy);
